import * as RadioGroup from '@radix-ui/react-radio-group'
import { buttonReset } from 'components/Button/Button.styles'
import { Stack } from 'components/Stack'
import { styled } from 'stitches.config'

export const RadioGroupStack = styled(Stack, {})

export const RadioGroupRoot = styled(RadioGroup.Root, {
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  color: '$accent-black',

  [`& ${RadioGroupStack}`]: {
    flexWrap: 'wrap',

    bp1: {
      flexWrap: 'nowrap',
    },
  },

  variants: {
    pill: {
      true: {
        '& button': {
          borderRadius: '$pill',
        },
      },
      false: {
        '& button': {
          borderRadius: '8px',
        },
      },
    },
  },
})

export const RadioGroupIndicator = styled(RadioGroup.Indicator, {
  size: '$3',
  borderRadius: '$round',
  border: '1px solid $tertiary-300',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '$2',
  flexShrink: 0,
  flexGrow: 1,
})

export const Checkmark = styled('div', {
  size: 'calc($3/2)',
  borderRadius: '$round',
})

export const RadioGroupOption = styled(RadioGroup.Item, {
  ...buttonReset,
  display: 'flex',

  '.help-text': {
    display: 'none',
  },

  '&:hover': {
    [`& ${RadioGroupIndicator}`]: {
      borderColor: '$tertiary-200',
    },
  },

  '&:focus': {
    outline: 'none',
    [`& ${RadioGroupIndicator}`]: {
      outline: '1px solid',
      outlineColor: 'blue',
    },
  },

  '&[aria-checked=true]': {
    [`& ${RadioGroupIndicator}`]: {
      borderColor: '$tertiary-400',
    },
    [`& ${Checkmark}`]: {
      backgroundColor: '$tertiary-400',
    },
    '.help-text': {
      display: 'initial',
    },
  },

  [`& ${RadioGroupIndicator}`]: {
    size: '$3',
    flexGrow: 0,
  },
})
